import { render, staticRenderFns } from "./currency-listing.vue?vue&type=template&id=39b5aa5e&scoped=true&"
import script from "./currency-listing.vue?vue&type=script&lang=js&"
export * from "./currency-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b5aa5e",
  null
  
)

export default component.exports